import { Navigate } from 'react-router-dom';
import { PRIVATE_ROUTE_PATHS, route } from '../../constants/routes';

const PrivateRouteFallback = () => (
  <Navigate to={route(PRIVATE_ROUTE_PATHS.dashboard)} replace />
);

export default PrivateRouteFallback;
